<template>
    <div></div>
</template>

<script>
    export default {
        name: "RollerNews"
    }
</script>

<style scoped>

</style>
